import React from "react"

const InputText = (props) => {
  return (
    <input
      type="text"
      className={props.className}
      placeholder={props.placeholder}
      aria-label={props.ariaLabel}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
    />
  )
}

export default InputText
